import { render, staticRenderFns } from "./PlansComp.vue?vue&type=template&id=f53f3558&scoped=true&"
import script from "./PlansComp.vue?vue&type=script&lang=js&"
export * from "./PlansComp.vue?vue&type=script&lang=js&"
import style0 from "./PlansComp.vue?vue&type=style&index=0&id=f53f3558&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f53f3558",
  null
  
)

export default component.exports